import { DISCOUNT_TYPES } from "../constants";
import { OfferInterface } from "../Types";

export const ProductArr = [
    {
        id: "gid://shopify/Product/9471244468546",
        images: [
            {
                id: "gid://shopify/ProductImage/45439151112514",
                altText: "",
                originalSrc:
                    "https://img.freepik.com/premium-photo/skateboard-3d-icon-png-image-isolated-object_913287-3228.jpg",
            },
        ],
        title: "Product 2",
        handle: "the-3p-fulfilled-snowboard",
        quantity: 1,
        maxProductStock: 20,
        selectedVariants: [],
        subscriptions: [],
        oneTimePurchase: true,
        isSubscribed: false,
        variants: [
            {
                price: "9000",
                quantity: 1,
                displayName: "Variant 1",
                quantityAvailable: 10,
                availableForSale: true,
            },
        ],
    },
    {
        id: "gid://shopify/Product/9471244501314",
        images: [
            {
                id: "gid://shopify/ProductImage/45439151210818",
                altText: "",
                originalSrc:
                    "https://img.freepik.com/free-vector/realistic-skate-board-set-with-blank-background-isolated-top-bottom-views-wooden-skateboard-vector-illustration_1284-83884.jpg",
            },
        ],
        title: "Product 3",
        handle: "the-collection-snowboard-oxygen",
        quantity: 1,
        maxProductStock: 50,
        selectedVariants: [],
        subscriptions: [],
        oneTimePurchase: true,
        isSubscribed: false,
        variants: [
            {
                price: "15000",
                quantity: 1,
                displayName: "Variant 2",
                quantityAvailable: 10,
                availableForSale: true,
            },
        ],
    },
];

export const OffersArr: OfferInterface[] = [
    {
        discount_type: DISCOUNT_TYPES.PERCENTAGE,
        discount_value: 0,
        quantity: 1,
        offer_title: "Buy 1",
        discount_label: "",
        discount_label_selected: false,
        discount_label_type: "none",
        discount_label_custom_img: "",
        discount_label_custom_img_size: 30,
        discount_label_custom_img_radius: 4,
        discount_label_custom_img_fit: "contain",
        tag: "Standard Price",
        tag_selected: false,
        allow_free_gifts: false,
        free_gifts: [],
        free_gift_text: "+Free Gift",
        allow_img: false,
        img_url: "",
        img_size: 50,
        img_radius: 8,
        img_fit: "cover",
        allow_extra_items: false,
        show_quantity_selector: false,
        free_gift_template: "old",
        free_gift_show_price: true,
        offer_type: "quantity_break",
        bundle_layout: "vertical",
        bundle_products: [],
        allow_upsell_products: false,
        upsell_products: [],
    },
    {
        discount_type: DISCOUNT_TYPES.PERCENTAGE,
        discount_value: 15,
        quantity: 2,
        offer_title: "Buy 2, Save {discount}",
        discount_label: "Best Seller",
        discount_label_selected: true,
        discount_label_type: "none",
        discount_label_custom_img: "",
        discount_label_custom_img_size: 30,
        discount_label_custom_img_radius: 4,
        discount_label_custom_img_fit: "contain",
        tag: "Most Popular",
        tag_selected: false,
        allow_free_gifts: false,
        free_gifts: [],
        free_gift_text: "+Free Gift",
        allow_img: false,
        img_url: "",
        img_size: 50,
        img_radius: 8,
        img_fit: "cover",
        allow_extra_items: false,
        show_quantity_selector: false,
        free_gift_template: "old",
        free_gift_show_price: true,
        offer_type: "quantity_break",
        bundle_layout: "vertical",
        bundle_products: [],
        allow_upsell_products: false,
        upsell_products: [],
    },
    {
        discount_type: DISCOUNT_TYPES.PERCENTAGE,
        discount_value: 20,
        quantity: 3,
        offer_title: "Buy 3, Save {discount}",
        discount_label: "",
        discount_label_selected: false,
        discount_label_type: "none",
        discount_label_custom_img: "",
        discount_label_custom_img_size: 30,
        discount_label_custom_img_radius: 4,
        discount_label_custom_img_fit: "contain",
        tag: "Best Price",
        tag_selected: false,
        allow_free_gifts: false,
        free_gifts: [],
        free_gift_text: "+Free Gift",
        allow_img: false,
        img_url: "",
        img_size: 50,
        img_radius: 8,
        img_fit: "cover",
        allow_extra_items: false,
        show_quantity_selector: false,
        free_gift_template: "old",
        free_gift_show_price: true,
        offer_type: "quantity_break",
        bundle_layout: "vertical",
        bundle_products: [],
        allow_upsell_products: false,
        upsell_products: [],
    },
];

export const discountOptions = [
    {
        id: 1,
        discountType: DISCOUNT_TYPES.PERCENTAGE,
        discountValue: 10,
        quantity: 2,
        maxQuantity: 2,
        addRange: false,
        allowExtraItems: false,
    },
    {
        id: 2,
        discountType: DISCOUNT_TYPES.PERCENTAGE,
        discountValue: 20,
        quantity: 3,
        maxQuantity: 3,
        addRange: false,
        allowExtraItems: false,
    },
];
